<ng-template #filterButtonRef>
  <span class="position-relative">
    <img
      class="filter-icon pointer-cursor mt-0"
      (click)="onFilterActivity()"
      src="assets/svg/ico-menu-circle.svg"
      alt="ico-menu-circle"
    />
    <span class="mf-badge" *ngIf="filterCount !== 0">
      <span class="circle-content">
        {{ filterCount || "" }}
      </span>
    </span>
  </span>
</ng-template>

<div
  class="user-activity d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 mb-3 w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="user-title m-auto col-10 text-center">
          <app-profile-tooltip [showHelpCursor]="true">
            {{
              this.profileDetails?.firstName +
                " " +
                this.profileDetails?.lastName
            }}
          </app-profile-tooltip>
        </span>
        <span class="modal-title m-auto">{{
          "USER_ACTIVITY" | translate
        }}</span>
      </div>
      <span class="col-2 d-flex cross-container">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="cross-button pointer-cursor"
          (click)="closeDialog()"
        />
      </span>
    </div>
  </div>
  <div class="header mt-1 mb-3 w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center"> </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="modal-title m-auto">{{ "ACTIVITY" | translate }}</span>
      </div>
      <span class="col-2 d-flex pr-2">
        <ng-template [ngTemplateOutlet]="filterButtonRef"></ng-template>
      </span>
    </div>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <div class="listing">
      <div
        class="scroll-container"
        #scrollContainer
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollUpDistance]="3"
        [infiniteScrollThrottle]="100"
        [scrollWindow]="false"
        (scrolled)="onScrollDown()"
        aria-live="polite"
        [attr.aria-busy]="loadingMore ? 'true' : 'false'"
      >
        <div class="activities-cards-wrapper">
          <ng-container
            *ngFor="
              let activity of userEvents;
              let i = index;
              trackBy: trackByOption
            "
          >
            <!-- Events with unitName -->
            <ng-container *ngIf="activity?.unitName">
              <ng-container
                *ngTemplateOutlet="
                  userActivityCardTpl;
                  context: { $implicit: activity }
                "
              ></ng-container>
            </ng-container>

            <!-- Events without unitName: apply access control -->
            <ng-container
              *ngIf="
                activity?.unitName === null ||
                activity?.unitName === undefined ||
                activity?.unitName === ''
              "
            >
              <ng-container *appHideAccess="commonAccessControl">
                <ng-container
                  *ngTemplateOutlet="
                    userActivityCardTpl;
                    context: { $implicit: activity }
                  "
                ></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>

        <ng-container *ngIf="userEvents.length === 0 && !isFetching">
          <p class="text text-center no-user-group">
            {{ "NO_USER_ACTIVITY_AVAILABLE" | translate }}
          </p>
        </ng-container>
        <div
          class="loading-indicator"
          *ngIf="(isFetching && userEvents.length === 0) || loadingMore"
        >
          <div class="spinner-small"></div>
          <span>Loading more...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Activity card template -->
<ng-template #userActivityCardTpl let-activity>
  <div class="activity-card" [ngClass]="getSeverityClass(activity)">
    <div class="activity-card-wrapper">
      <div class="activity-content">
        <div class="activity-icon-section">
          <img
            [src]="getEventIcon(activity)"
            alt="icon"
            class="activity-icon"
          />
        </div>

        <div class="activity-details">
          <div class="activity-title">
            <div class="lock-name-wrap">
              <app-with-tooltip [showHelpCursor]="true">
                {{ activity?.deviceName }}
              </app-with-tooltip>
            </div>
            <span
              class="activity-title-status"
              *ngIf="activity?.eventTitle || activity?.eventDescription"
            >
              <app-with-tooltip [showHelpCursor]="true"
                >:
                {{
                  activity?.eventTitle || activity?.eventDescription
                }}</app-with-tooltip
              >
            </span>
          </div>

          <!-- Extra description -->
          <div
            class="activity-description"
            *ngIf="activity?.extraDescription && hasExtraDescription(activity)"
          >
            <app-with-tooltip
              [showHelpCursor]="true"
              class="description-text"
              >{{ activity?.extraDescription }}</app-with-tooltip
            >
          </div>

          <!-- Source line -->
          <div class="activity-source" *ngIf="activity?.source">
            <img
              src="assets/svg/ico-lock-access-settings.svg"
              alt="icon"
              class="source-icon"
            />
            <app-with-tooltip [showHelpCursor]="true" class="source-text">{{
              getSourceDisplay(activity)
            }}</app-with-tooltip>
          </div>

          <!-- User name -->
          <div class="activity-user" *ngIf="activity?.user">
            <app-with-tooltip [showHelpCursor]="true" class="user-text">{{
              activity?.user
            }}</app-with-tooltip>
          </div>
        </div>

        <div class="activity-metadata">
          <div class="activity-date">
            {{ activity?.isoTime | parsedActivityDateTime : "MMM dd" : true }}
          </div>
          <div class="activity-time">
            {{ activity?.isoTime | parsedDateTime : "hh:mm a" }}
          </div>
        </div>
      </div>

      <!-- Collapsed location bar -->
      <div
        class="activity-location"
        *ngIf="
          expandedActivityId !== activity?.id &&
          (activity?.buildingName || activity?.unitName)
        "
      >
        <div class="location-items">
          <div class="location-group" *ngIf="activity?.buildingName">
            <span class="location-icon">
              <img src="assets/svg/ico-building-gray.svg" alt="icon" />
            </span>
            <span class="location-name">
              <app-with-tooltip [showHelpCursor]="true">{{
                activity?.buildingName
              }}</app-with-tooltip>
            </span>
          </div>
          <div class="location-group" *ngIf="activity?.unitName">
            <span class="location-icon">
              <img src="assets/svg/ico-default-home.svg" alt="icon" />
            </span>
            <span class="location-name">
              <app-with-tooltip [showHelpCursor]="true">{{
                activity?.unitName
              }}</app-with-tooltip>
            </span>
          </div>
        </div>
        <span
          class="chevron-dropdown-container"
          (click)="toggleDropdown(activity?.id)"
        >
          <img
            src="assets/svg/ico-chevron-down-outline-all-acces.svg"
            class="pointer-cursor chevron-icon"
          />
        </span>
      </div>

      <!-- Expanded location details -->
      <div
        class="activity-location-expanded"
        *ngIf="
          expandedActivityId === activity?.id &&
          (activity?.buildingName || activity?.unitName)
        "
      >
        <div class="expanded-header">
          <span
            class="chevron-dropdown-container"
            (click)="toggleDropdown(activity?.id)"
          >
            <img
              src="assets/svg/ico-up-arrow.svg"
              class="pointer-cursor chevron-icon"
            />
          </span>
        </div>
        <div class="dropdown-detail-item" *ngIf="activity?.buildingName">
          <img
            src="assets/svg/ico-building-gray.svg"
            alt="building"
            class="dropdown-detail-icon"
          />
          <span class="dropdown-detail-text">{{ activity?.buildingName }}</span>
        </div>
        <div class="dropdown-detail-item" *ngIf="activity?.floorName">
          <img
            src="assets/svg/ico-floor.svg"
            alt="floor"
            class="dropdown-detail-icon"
          />
          <span class="dropdown-detail-text">{{ activity?.floorName }}</span>
        </div>
        <div class="dropdown-detail-item" *ngIf="activity?.wingName">
          <img
            src="assets/svg/ico-direction.svg"
            alt="wing"
            class="dropdown-detail-icon"
          />
          <span class="dropdown-detail-text">{{ activity?.wingName }}</span>
        </div>
        <div class="dropdown-detail-item" *ngIf="activity?.unitName">
          <img
            src="assets/svg/ico-default-home.svg"
            alt="unit"
            class="dropdown-detail-icon"
          />
          <span class="dropdown-detail-text">{{ activity?.unitName }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
